const sectionFeaureProducts = document.querySelector(".home-feature-products");
const productCards = document.querySelectorAll(".slide-up-ease");

const options = {
    root: null, 
    threshold: 0,
    rootMargin: "-100px"
}

const callback = function(entries, observer) {
    entries.forEach(element => {
        
        if (!element.isIntersecting) return;
        
        element.target.classList.toggle('inverse');
        observer.unobserve(element.target)
    });
}

const observer = new IntersectionObserver(callback, options);

// observer.observe(sectionFeaureProducts); 
productCards.forEach(productCard => {
    observer.observe(productCard);
})


// fadeIn observer 

const headings = document.querySelectorAll('.fade-in');
const ingItems = document.querySelectorAll('.slide-lft');
const fadeUpItems = document.querySelectorAll('.slide-up');

const fadeInOption = {  
    threshold: 0,
    rootMargin: "0px 0px -150px 0px"
}

const fadeInCallback = function(item, observer) {
    item.forEach(element => {
        if (!element.isIntersecting) return;
        
        element.target.classList.toggle('appear');
        observer.unobserve(element.target)
    });
}

const fadeInObserver = new IntersectionObserver(fadeInCallback, fadeInOption);


headings.forEach(heading => {
    fadeInObserver.observe(heading);
})

ingItems.forEach(ingItem => {
    fadeInObserver.observe(ingItem);
})

fadeUpItems.forEach(item => {
    fadeInObserver.observe(item);
})


// sticky header 
// const header = document.querySelector('#shopify-section-header');
// const homeHero = document.querySelector('.hero-title'); 

// const stickyHeaderOption = {
//     rootMargin: "-250px 0px 0px 0px"
// }

// const stickyHeaderCallback = function(item, observer) {
//     item.forEach(element => {
//         if (!element.isIntersecting) {
//             header.classList.add('sticky-header-shadow')
//         } else {
//             header.classList.remove('sticky-header-shadow')
//         }
//     });
// }

// const stickyHeaderObserver = new IntersectionObserver(stickyHeaderCallback, stickyHeaderOption);

// stickyHeaderObserver.observe(header);

let header = document.querySelector('#shopify-section-header');
let headerBounds = {};
let currentScrollTop = 0;


function onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > currentScrollTop) { 
        header.classList.add('sticky-header-shadow')
    } else {
        header.classList.remove('sticky-header-shadow')
    }
}

window.addEventListener('scroll', onScroll);
window.onload = onScroll;


